import { ReactNode, useRef } from 'react';
import { StateStorage } from 'zustand/middleware';
import { WalletContext } from '../context/walletContext';
import { createWalletStore } from '../store/walletStore';
import { createInMemoryStore } from '../utils/stateStorage';
import { WALLETS_INFO_STORAGE_KEY } from '../utils/wallet.util';
import { useInitWalletConnections } from '../hooks/useInitWalletConnections';
import { useActiveWalletSync } from '../hooks/useActiveWalletSync';
import { useZkLoginJwtSync } from '../hooks/useZkLoginJwtSync';

export const DEFAULT_STORAGE = typeof window !== 'undefined' && window.localStorage ? localStorage : createInMemoryStore();

export type WalletProviderProps = {
	storage?: StateStorage | null;
	storageKey?: string;
	bootstrapReady?: boolean;
	children: ReactNode;
};

export function WalletProvider({
	storage = DEFAULT_STORAGE,
	storageKey = WALLETS_INFO_STORAGE_KEY,
	bootstrapReady = true,
	children,
}: WalletProviderProps) {
	const storeRef = useRef(
		createWalletStore({
			storage: storage || createInMemoryStore(),
			storageKey,
		}),
	);

	return (
		// eslint-disable-next-line react-hooks/refs
		<WalletContext.Provider value={storeRef.current}>
			<WalletConnectionManager bootstrapReady={bootstrapReady}>{children}</WalletConnectionManager>
		</WalletContext.Provider>
	);
}

type WalletConnectionManagerProps = Pick<WalletProviderProps, 'children' | 'bootstrapReady'>;

function WalletConnectionManager({ children, bootstrapReady = true }: WalletConnectionManagerProps) {
	useInitWalletConnections(bootstrapReady);
	useActiveWalletSync(bootstrapReady);
	useZkLoginJwtSync(bootstrapReady);

	return children;
}
